import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';

interface StatusConfig {
  label: string;
  color: ChipProps['color'];
  variant?: ChipProps['variant'];
}

const APPRAISAL_STATUS_MAP: Record<string, StatusConfig> = {
  NotStarted: { label: 'NOT STARTED', color: 'default' },
  SelfAssessment: { label: 'SELF-ASSESSMENT', color: 'info' },
  CollatorReview: { label: 'COLLATOR REVIEW', color: 'primary' },
  CollatorUpdates: { label: 'COLLATOR REVIEW', color: 'primary' },
  TcReview: { label: 'READY FOR TC', color: 'success' },
  AwaitingHrGuidance: { label: 'AWAITING HR GUIDANCE', color: 'warning' },
  StaffingReview: { label: 'STAFFING REVIEW', color: 'warning' },
  StaffingAccepted: { label: 'STAFFING ACCEPTED', color: 'success' },
  ReadyForDelivery: { label: 'READY FOR DELIVERY', color: 'success' },
  Delivered: { label: 'DELIVERED', color: 'success' },
  DeliveryAcknowledged: { label: 'DELIVERY ACKNOWLEDGED', color: 'success' },
  Planned: { label: 'PLANNED', color: 'default', variant: 'outlined' },
  Completed: { label: 'COMPLETED', color: 'success' },
};

interface AppraisalStatusChipProps {
  status: string;
}

export function AppraisalStatusChip({ status }: AppraisalStatusChipProps) {
  const config = APPRAISAL_STATUS_MAP[status] ?? { label: status.toUpperCase(), color: 'default' as const };

  return (
    <Chip
      label={config.label}
      size="small"
      color={config.color}
      variant={config.variant ?? 'filled'}
    />
  );
}

export default AppraisalStatusChip;
